import { Box, Typography } from '@mui/material'
import Icon from '../../../../../../components/icon'
import { TOOLTIPS } from '../../../../../../utils/tooltips'

const RenderScore = ({ scoreData, onEdit }) => {
  if (scoreData == null) return null

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: 'rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset',
        borderRadius: '6px',
        padding: '5px 10px',
        backgroundColor: 'var(--grey-200)'
      }}
    >
      <Icon
        icon="clarity:bullseye-line"
        fontSize={14}
        style={{ color: 'var(--primary-main)' }}
      />
      <Typography
        fontSize={'12px'}
        lineHeight={1}
        display="flex"
        alignItems="center"
        gap="4px"
      >
        <span>Score:</span>
        <span
          style={{
            color:
              scoreData > 70
                ? 'var(--success-main)'
                : scoreData > 40
                  ? 'var(--warning-main)'
                  : 'var(--error-main)',
            fontWeight: 800
          }}
        >
          {scoreData}%
        </span>
      </Typography>
      {onEdit && (
        <Icon
          icon="mdi:pencil"
          fontSize={14}
          onClick={onEdit}
          style={{ color: 'var(--primary-main)' }}
          title={TOOLTIPS.editScore}
          nonHoverBoxStyle={{ cursor: 'pointer' }}
        />
      )}
    </Box>
  )
}

export default RenderScore
